import { useQuery } from '@tanstack/react-query';

import { MetadataClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const metadataClient = new MetadataClient(apiBaseUrl);

function useGetFormMetadata(componentName: string) {
  return useQuery({
    queryKey: [queryKeys.Metadata.Metadata, { componentName }],
    queryFn: () => metadataClient.getFormMetadata(componentName),
  });
}

export default useGetFormMetadata;
